import { render, staticRenderFns } from "./CandidateModal.vue?vue&type=template&id=041e56cf&scoped=true"
import script from "./CandidateModal.vue?vue&type=script&lang=js"
export * from "./CandidateModal.vue?vue&type=script&lang=js"
import style0 from "./CandidateModal.vue?vue&type=style&index=0&id=041e56cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041e56cf",
  null
  
)

export default component.exports